<template>
  <div>
    <div id="concentration" v-if="isShelves">
      <span id="anchorTagOne"></span>
      <Left v-if="isOk" :detailsData="detailsData"></Left>
      <Center v-if="isOk" :detailsData="detailsData"></Center>
      <Right
        v-if="isOk"
        :detailsData="detailsData"
        :autherInfo="autherInfo"
        :relatedList="relatedList"
        :number="number"
      />
    </div>
    <div id="concentration" v-else>
      <Shelves />
    </div>
  </div>
</template>

<script>
// import { nextTick } from "vue/types/umd";
import Left from "../components/left";
import Center from "./components/center";
import Right from "./components/Right";
import Shelves from "../components/shelves";
import {changeTitle, changeKeywords, changeDescription} from "@/utils/brower.js";
export default {
  name: "index",
  components: { Left, Center, Right, Shelves },
  data() {
    return {
      isShelves: true,
      isOk: false, // 等待数据加载完在加载子组件
      detailsData: {}, // 会议详细信息
      autherInfo: {}, // 发布者信息
      number: {}, // 发布至文献数
      relatedList: [], // 相关文献
    };
  },
  created() {
    this.getDetails();
  },
  methods: {
    async PublisherInfo(companyId, createUser) {
      const numData = await this.$apis.recomendServe.PublisherInfo({
        companyId,
        createUser,
      });
      this.number = numData.data;
    },
    // 获取相关文献
    async getPublisher(companyId) {
      let resp = await this.$apis.recomendServe.getPublisher({ companyId });
      this.relatedList = [...resp.data];
    },
    // 获取发布者信息
    async getAuthor(companyId, type) {
      const res = await this.$apis.recomendServe.getAuthor({ type, companyId });
      this.autherInfo = res.content;
    },
    // 获取详情
    async getDetails() {
      const res = await this.$apis.recomendServe.getMeetingDetails({
        id: this.$router.history.current.query.id,
        projectId: 1,
      });
      if (res.resultCode === "200") {
        this.detailsData = res;
        changeTitle(this.$global.matchReg(res.data.title))
        changeKeywords(res.data.keyword)
        changeDescription(this.$global.matchReg(res.data.artSummary))
        await this.getPublisher(res.data.companyId);
        await this.getAuthor(res.data.companyId, res.data.userType);
        await this.PublisherInfo(res.data.companyId, res.data.createUser);
        this.isOk = true;
      } else if (res.resultCode === "10401002" || res.resultCode === "10401001") {
        this.isShelves = false
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#concentration {
  width: 1200px;
  display: flex;
}
</style>
